/**
 * Navigate to a URL with a full page reload
 * This is used when we need to ensure the session is properly loaded server-side
 */
export const reloadPageTo = (url: string) => {
  // In test mode, we don't actually navigate
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line no-console
    console.log('Detected test environment, not navigating to', url);
    return;
  }
  window.location.href = url;
};
